import type { FunctionComponent } from "preact";
import { useEffect } from "preact/hooks";
import { useLocation } from "preact-iso";

import { withAuth } from "#utils/auth.js";

const Home: FunctionComponent = withAuth(() => {
	const location = useLocation();
	useEffect(() => {
		const chatId = crypto.randomUUID();
		location.route(`/chat/${chatId}`, true);
	}, []);
	return "redirecting...";
});
export default Home;
